module.exports = __webpack_public_path__ + "img/ethereum-2.0.98b9b227.png";